<template>
  <rp-permissions :requireAll="['read_users', 'write_users']">
    <div v-if="show" class="sidebar-links">
      <router-link :to="{name: 'all-users', params: {sideNav: true}}" exact>Users</router-link>
      <router-link to="/users/activation" exact>Users Activation</router-link>
      <router-link to="/users/add-user" exact>Add User</router-link>
    </div>
  </rp-permissions>
</template>

<script>
import Permissions from 'raypro_ui/src/components/Permissions'

export default {
  components: {'rp-permissions': Permissions},
  computed: {
    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('^/patients').test(this.path) ||
        new RegExp('^/operations').test(this.path) ||
        new RegExp('^/surgeons').test(this.path) ||
        new RegExp('^/nurses').test(this.path) ||
        new RegExp('^/users').test(this.path) ||
        new RegExp('^/hospital_admins').test(this.path) ||
        new RegExp('^/raypro_admins').test(this.path)
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/UsersLinks.vue